// extracted by mini-css-extract-plugin
export default {"addressBookIndex":"index_addressBookIndex__Kt954"};